import { render, staticRenderFns } from "./ForumTnc.vue?vue&type=template&id=62432cce&"
import script from "./ForumTnc.vue?vue&type=script&lang=js&"
export * from "./ForumTnc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports